export default __webpack_public_path__ + "static/media/tituloEN.1bbbdc1b.png";